import React from 'react'
import styled from 'styled-components';
import { Color, Colors } from '../styles/Colors';
import { useContext } from 'react';
import { AgendaContext } from '../context/AgendaContext';
import { useTranslation } from 'react-i18next';

const Content = styled.div` 
    & > div {
        display: flex; 
        border-bottom: 3px double ${Color(Colors.black)}; 
        border-top: 2px solid ${Color(Colors.black)}; 
        margin: 0.5rem 0 1rem 0; 

        & > div {
            flex: 1; 
            display: flex; 
            flex-direction: column; 
            
            & > span {
                padding: 0.5rem; 
            }

            & > span:first-of-type {
                border-bottom: 3px double ${Color(Colors.black)};
                font-weight: 600; 
            }
        }

        & > div:first-of-type {
            border-right: 2px dashed ${Color(Colors.black)}; 

        }
    }
    
    padding: 0 0 0.5rem 0; 

    &:not(:last-of-type) {
        padding: 0 0 1.25rem 0; 
    }

   & > p {
    font-style: italic; 
   }
`;


const ProposalForSweTitles = () => {
    const { t } = useTranslation(); 
    const { proposalForSweTitles } = useContext(AgendaContext); 
    return (
        <div>
            {proposalForSweTitles && proposalForSweTitles.length > 0 ? (
                proposalForSweTitles.map((title, index) => (
                    <Content key={index}>
                        <div>
                            <div>
                                <span>{title.iec}</span>
                                <span>{title.title_en_us}</span>
                            </div>
                            <div>
                                <span>{title.sek}</span>
                                <span></span>
                            </div>
                        </div>
                        <p>{`${t('proposalForSwedishTitles.deadline')} ${new Date(title.subtracted_dop).toLocaleDateString()}.`}</p>
                    </Content>
                ))

            ) : (
                <span>{t('common.noContent')}</span>
            )}
        </div>
    )
}

export default ProposalForSweTitles